import React from 'react';
import styles from './dayCell.module.css';

function DayCell({ date, isCurrentMonth, hasAppointment, isSelected, onSelect }) {
    const dayNumber = date.getDate();

    const className = [
        styles.cell,
        !isCurrentMonth && styles.outsideMonth,
        hasAppointment && styles.hasAppointment,
        isSelected && styles.selected,
    ].filter(Boolean).join(' ');

    return (
        <button
            type="button"
            className={className}
            disabled={!isCurrentMonth}
            onClick={isCurrentMonth ? onSelect : undefined}
            aria-pressed={isSelected}
        >
            <span className={styles.dayNumber}>{dayNumber}</span>
            {hasAppointment && <span className={styles.appointmentDot} />}
        </button>
    );
}

export default DayCell;
